import baccaratproject from '../assets/images/baccaratproject.png';

const Baccarat = () => {
  return (
    <div>
      <a href='#projects'><strong>Javascript</strong> Game</a>
      <img src={baccaratproject} alt='baccarat' className='' />
    </div>
  )
}

export default Baccarat;